import React from "react";
import "./ArtworkCertificate.scss";

const ArtworkCertificate = ({ title = "", description = "" }) => {
  return (
    <div className="artwork-certificate">
      <div className="certificate-header">
        <h1 className="certificate-title">{title}</h1>
        <p className="certificate-description">{description}</p>
      </div>

      {/* <div className="certificate-box"></div> */}
    </div>
  );
};

export default ArtworkCertificate;
